import React from 'react';
import { withAuth } from '~/auth';
import { Section } from '~/components/common/section';
import AttendeesList from '~/components/attendees-list';
import { Translate, useTranslate } from '~/i18n';
import { NextSeo } from 'next-seo';

const AttendeesListPage = () => {
   const { translate } = useTranslate();

   return (
      <>
         <NextSeo
            title={translate({
               id: 'pageTitles:attendees list',
            })}
         />
         <Section className="py-8 my-8">
            <div className="lg:px-8 px-4">
               <div className="text-black flex flex-col gap-4 md:flex-row md:columns-2 justify-between border-b border-grey-500 pb-8">
                  <div>
                     <div className="sm:text-3xl text-xl font-bold mb-3">
                        <Translate id="operations:attendees list" />
                     </div>
                     <div className="text-sm whitespace-pre-line">
                        <Translate id="operations:attendees list description" />
                     </div>
                  </div>
               </div>

               <AttendeesList />
            </div>
         </Section>
      </>
   );
};

export default withAuth(AttendeesListPage);
